<!-- Email Interface -->
<div class="relative">
    <div *ngIf="!isAccountNotConnected" class="flex w-full gap-4 p-4 min-h-screen 
         bg-gradient-to-br from-slate-50 to-blue-50 
         dark:from-gray-900 dark:to-gray-800">

        <!-- Left Sidebar - Actions -->
        <div class="flex-none w-64 h-[calc(92vh-100px)]">
            <p-card class="h-full shadow-lg hover:shadow-xl transition-shadow duration-300 rounded-2xl">
                <div class="h-full">
                    <app-mail-left-actions [isAccountNotConnected]="isAccountNotConnected" [updateDraft]="updateDraft"
                        [activeAction]="activeAction" (actionChange)="onActionChange($event)"
                        (isCompose)="handleCompose()" (refresh)="handleUpdateData2()">
                    </app-mail-left-actions>
                </div>
            </p-card>
        </div>


        <!-- Middle Section - Email List -->
        <div class="flex-none w-[30%] max-w-[30%] overflow-x-hidden">
            <p-card class="h-full shadow-lg hover:shadow-xl transition-shadow duration-300 rounded-2xl">

                <div *ngIf="activeAction === 'inbox'">
                    <app-mail-middle-section [isAccountNotConnected]="isAccountNotConnected"
                        (changeAccountNotConnected)="handleAccountNotConnected($event)"
                        (selecteRow)="handleSelectRow($event)" [activeAction]="activeAction"></app-mail-middle-section>
                </div>

                <div *ngIf="activeAction === 'sent'">
                    <app-mail-middle-section [isAccountNotConnected]="isAccountNotConnected"
                        (changeAccountNotConnected)="handleAccountNotConnected($event)"
                        (selecteRow)="handleSelectRow($event)" [activeAction]="activeAction"></app-mail-middle-section>
                </div>

                <div *ngIf="activeAction === 'drafts'">
                    <app-mail-middle-section [isAccountNotConnected]="isAccountNotConnected"
                        (changeAccountNotConnected)="handleAccountNotConnected($event)"
                        (selecteRow)="handleSelectRow($event)" [activeAction]="activeAction"></app-mail-middle-section>
                </div>

                <div *ngIf="activeAction === 'trash'">
                    <app-mail-middle-section [isAccountNotConnected]="isAccountNotConnected"
                        (changeAccountNotConnected)="handleAccountNotConnected($event)"
                        (selecteRow)="handleSelectRow($event)" [activeAction]="activeAction"></app-mail-middle-section>
                </div>

                <div *ngIf="activeAction === 'deleted'">
                    <app-mail-middle-section [isAccountNotConnected]="isAccountNotConnected"
                        (changeAccountNotConnected)="handleAccountNotConnected($event)"
                        (selecteRow)="handleSelectRow($event)" [activeAction]="activeAction"></app-mail-middle-section>
                </div>

            </p-card>
        </div>

        <!-- Right Section - Email Content -->
        <div class="flex-1">
            <p-card class="h-full shadow-lg hover:shadow-xl transition-shadow duration-300 rounded-2xl">
                <app-mail-right-section [isComposeOpen]="isComposeOpen" [isDraft]="isDraft" [selectedRow]="selectedRow"
                    [activeAction]="activeAction" (refresh)="handleUpdateData2()" [loadingEmailData]="loadingEmailData"
                    (closeCompose)="handleComposeClose()" (makeIsDraftFalse)="handleMakeIsDraftFalse()"
                    [sanitizedContent]="sanitizedContent" [fetchingDraftData]="fetchingDraftData"
                    (closeCompose2)="handleSaveImageandUpdateDraft()" (composeNewEmail)="handleCompose()"
                    [currentCreatedDraftId]="currentCreatedDraftId"></app-mail-right-section>
            </p-card>
        </div>
    </div>

    <!-- Account Not Connected -->
    <div *ngIf="isAccountNotConnected" class="min-h-screen flex items-center justify-center">
        <p-card class="w-full max-w-md shadow-2xl">
            <div class="text-center p-6"> <!-- Warning Icon -->
                <div class="mb-6">
                    <div
                        class="w-20 h-20 bg-gradient-to-r from-orange-400 to-red-500 rounded-full flex items-center justify-center mx-auto shadow-lg">
                        <i class="pi pi-exclamation-triangle text-3xl text-white"></i>
                    </div>
                </div> <!-- Title -->
                <h2 class="text-2xl font-bold text-gray-800 dark:text-white mb-4"> Account Not Connected </h2>
                <!-- Message -->
                <p class="text-gray-600 dark:text-gray-100 mb-6 leading-relaxed"> Your email account needs to be
                    connected
                    to access your
                    emails. Please click the button below to establish the connection. </p> <!-- Connect Button -->
                <p-button label="Connect Now" [loading]="isConnectLoading" loadingIcon="pi pi-spin pi-spinner"
                    icon="pi pi-plug" (onClick)="handleConnectAccount()"
                    styleClass="w-full p-button-lg p-button-raised">
                </p-button> <!-- Additional Help Text -->
                <p class="text-sm text-gray-500 dark:text-gray-200 mt-4"> Having trouble? Contact support for
                    assistance.
                </p>
            </div>
        </p-card>
    </div>

    <!-- Loading State -->
    <div *ngIf="initLoading"
        class="flex flex-col items-center justify-center min-h-screen bg-white space-y-6 absolute top-0 w-full">

        <!-- Gradient Ring Loader -->
        <div class="relative w-20 h-20">
            <div
                class="absolute inset-0 rounded-full border-4 border-t-transparent border-b-transparent border-gradient-to-r from-blue-500 via-purple-500 to-pink-500 animate-spin">
            </div>
            <div class="absolute inset-2 rounded-full bg-white"></div>
        </div>

        <!-- Loading Text -->
        <p class="text-gray-600 text-lg font-medium animate-pulse">
            Please wait, loading your data...
        </p>
    </div>

</div>

<!-- Confirmation Dialog -->
<!-- <p-confirmDialog></p-confirmDialog> -->